module.exports = __webpack_public_path__ + "img/access-point.7ddac319.svg";